var ScorecardCategoryPunchcardView;
(function (ScorecardCategoryPunchcardView) {
    /**
     * These is used for the different
     * views related to the punchcard
     * scorecard view.
     */
    /** Default view */
    ScorecardCategoryPunchcardView[ScorecardCategoryPunchcardView["defaultView"] = 0] = "defaultView";
    /** Punch view should have description on the card */
    ScorecardCategoryPunchcardView[ScorecardCategoryPunchcardView["descriptionOnCardView"] = 1] = "descriptionOnCardView";
    /** All punches should have no name shown on the card */
    ScorecardCategoryPunchcardView[ScorecardCategoryPunchcardView["noActionNamesView"] = 2] = "noActionNamesView";
    /** Punch View for only one punch */
    ScorecardCategoryPunchcardView[ScorecardCategoryPunchcardView["onePunchView"] = 3] = "onePunchView";
})(ScorecardCategoryPunchcardView || (ScorecardCategoryPunchcardView = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { ScorecardCategoryPunchcardView };
